import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { BillOfLandingService } from "./bill-of-landing.service";
import { Observable, of, catchError, finalize } from "rxjs";
import { IBillOfLandingGetDTO } from "./models";
import { LoaderService } from "src/app/shared/components/loader/loader.service";
import { TimeUtil } from "src/app/shared/services/time-util.service";

export const billOfLandingResolver: ResolveFn<
  Observable<IBillOfLandingGetDTO[]>
> = () => {
  const billOfLandingService = inject(BillOfLandingService);
  const loaderService = inject(LoaderService);
  loaderService.show();
  const timeUtil = inject(TimeUtil);
  return billOfLandingService
    .get({
      date: timeUtil.formatDateLocalYYYYMMDD(new Date()),
      soNumber: "",
    })
    .pipe(
      catchError(() => of([])),
      finalize(() => {
        loaderService.hide();
      })
    );
};
